// Scrollbeeld en menukaart van Vakmanschap en Proeflokaal. Zonder beweging staat alles gewoon af.
(function () {
  // tabbladen van de menukaart werken ook zonder animaties
  document.querySelectorAll('[data-p5-boek]').forEach(function (b) {
    var tabs = [].slice.call(b.querySelectorAll('[role=tab]'));
    function kies(t) {
      tabs.forEach(function (x) {
        var aan = x === t; x.setAttribute('aria-selected', aan); x.tabIndex = aan ? 0 : -1;
        document.getElementById(x.getAttribute('aria-controls')).hidden = !aan;
      });
    }
    b.addEventListener('click', function (e) { var t = e.target.closest('[role=tab]'); if (t) kies(t); });
    b.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement); if (i < 0) return;
      var n = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? i + 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? i - 1 : -1;
      if (n < 0 && !(e.key === 'ArrowLeft' || e.key === 'ArrowUp')) return;
      e.preventDefault(); var t = tabs[(n + tabs.length) % tabs.length]; kies(t); t.focus();
    });
  });
  if (!window.gsap || !window.ScrollTrigger || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // grote foto's zoomen rustig mee met het scrollen
  gsap.utils.toArray('[data-p5-zoom]').forEach(function (f) {
    gsap.fromTo(f, { scale: 1.1 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: f.parentNode, start: 'top bottom', end: 'bottom top', scrub: 0.6 } });
  });
  gsap.utils.toArray('[data-p5-zweef]').forEach(function (f) {
    gsap.fromTo(f, { yPercent: -5, scale: 1.1 }, { yPercent: 5, scale: 1.1, ease: 'none', scrollTrigger: { trigger: f.parentNode, start: 'top bottom', end: 'bottom top', scrub: 0.6 } });
  });
  // telefoon: een rij blijft staan en loopt met het scrollen naar rechts, aan het einde gaat de pagina verder
  gsap.matchMedia().add('(max-width: 749px)', function () {
    var secties = [];
    [['.p2-schap', '.p2-paneel:not([hidden]) .p2-rail'], ['.p2-specials', '.p2-banen'], ['.p2-bezoek', '.p2-bezoek__rij'], ['.p3-fotorij', '.p3-fotorij__rij'], ['.p5-whisky', '.p5-whisky__rij']].forEach(function (p) {
      gsap.utils.toArray(p[0]).forEach(function (s) {
        var rij = function () { return s.querySelector(p[1]); }, r = rij();
        if (!r) return;
        s.classList.add('is-meeveeg');
        var afstand = r.scrollWidth - r.clientWidth;
        if (afstand < 8) { s.classList.remove('is-meeveeg'); return; }
        secties.push(s);
        ScrollTrigger.create({
          trigger: s, pin: true, anticipatePin: 1, end: '+=' + afstand,
          start: function () { return s.offsetHeight > innerHeight + 2 ? 'bottom bottom' : 'top top'; },
          onUpdate: function (t) { var x = rij(); if (x) x.scrollLeft = t.progress * (x.scrollWidth - x.clientWidth); }
        });
      });
    });
    ScrollTrigger.sort(); ScrollTrigger.refresh();
    return function () { secties.forEach(function (s) { s.classList.remove('is-meeveeg'); }); };
  });
})();
